import React from 'react';
import ExportCsvService from '../services/ExportCsvService';
import ImportCsvService from '../services/ImportCsvService';
import LocalizationListScene from './LocalizationListScene';

class LocalizationListSceneContainer extends React.Component {
  render() {
    return (
      <LocalizationListScene
        handleExportCsvDialog={ExportCsvService.handleOpenDialog}
        handleImportCsvDialog={ImportCsvService.handleOpenDialog}
        location={this.props.location}
      />
    );
  }
}

export default LocalizationListSceneContainer;
